<template>
    <el-drawer
        title="新增/编辑口令"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                label-position="top"
                size="medium"
            >
                
                <el-form-item prop="name" label="口令名称:">
                    <el-input v-model="formData.name" placeholder="请输入口令名称" maxlength="20" show-word-limit></el-input>
                </el-form-item>
                <el-form-item prop="datetimerange" label="口令有效期:" :rules="[{ required: true, message: '请设置口令有效期' }]">
                    <el-date-picker
                        v-model="formData.datetimerange"
                        type="datetimerange"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        value-format="yyyy-MM-dd HH:mm:ss"
						format="yyyy-MM-dd HH:mm"
                        size="medium"
                        unlink-panels
                    ></el-date-picker>
					
                </el-form-item>
                <el-form-item prop="couponRuleId" label="关联优惠券:">                   
					<el-select
					    v-model="formData.couponRuleId" 
					    filterable
					    remote
					    :remote-method="searchCoupon"
					    :loading="couponLoading"
					    placeholder="请输入优惠券ID"
					    value-key="id"
					    >
					    <el-option v-for="item in couponList" :key="item.id" :value="(item.id).toString()" :label="item.id + '-' + item.name"></el-option>
					</el-select>
                </el-form-item>
				<el-form-item prop="receiveNum" label="领取人数:">
				    <el-input-number  v-model="formData.receiveNum" :precision="0" controls-position="right" :min="1" :max="99999999" style="width:100%"></el-input-number>
				</el-form-item>
                <el-form-item prop="remark" label="备注:">
                    <el-input v-model="formData.remark" placeholder="请输入备注" maxlength="20" show-word-limit></el-input>
                </el-form-item>
				<el-form-item prop="commendCode" label="口令内容:" v-if="formData && formData.commendCode">
				        {{formData.commendCode}}
				</el-form-item>
				</el-form>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >确认</el-button
            >
        </div>
    </el-drawer>
</template>
<script>
const defaultData = {
	id:'',
    name: "",
    couponRuleId: "",
    receiveNum: "",
    remark:'',
	datetimerange:[]
}
export default {
    
    data(){
       
        return{
            drawerShow: false,
            btnLoading: false,
            formData:{
                ...defaultData
            },
			
			datetimerange:[],
            rules:{
                couponRuleId:[{ required: true, message: "请关联优惠券" }],
                name:[{ required: true, message: "请输入口令名称" }],				
                receiveNum:[{ required: true, message: "请输入领取人数" }],
            },
			couponList: [],
			couponLoading:false
        }
    },
    methods:{
        close(){
            this.$refs.formData.resetFields();
            this.drawerShow = false;
            this.formData = {
                ...defaultData,
				
            }
        },
        show(data){
            this.formData = data ? {
                ...defaultData,
                ...data,
				datetimerange:[data.startTime + ':00',data.endTime + ':00'],
				couponRuleId: data.couponRuleId != null ? String(data.couponRuleId) : ''
            } 
            : {...defaultData};
			if(data && data.couponRuleId ){
			    this.searchCoupon(data.couponRuleId);
			}
            this.drawerShow = true;
        },
		//检验id有效性
		searchCoupon(query){
		    if(query !== ""){
		        this.couponLoading = true;
		        this.$request({
		            url: "/lottery/prize/parsingCouponRule",
		            params: {
		                couponRuleId: query,
		            },
		            method: "post",
		        })
		            .then((res) => {
		                const { state, msg, result } = res.data;
		                if (state == 1) {
		                    this.couponList = Array.isArray(result) ? result : [result];
		                } else {
		                    this.couponList = [];
		                    this.$message.error(msg || "查询失败,请重试");
		                }
		            })
		            .catch(() => {
		                this.couponList = [];
		                this.$message.error("查询失败,请重试");
		            })
		            .finally(() => {
		                this.couponLoading = false;
		            });
		    }
		},
        submitForm(){
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;    
                    this.$request({
                        url: '/promotion/commend/edit',
                        data: {...this.formData,
							startTime:this.formData.datetimerange && this.formData.datetimerange[0] || '',
							endTime:this.formData.datetimerange && this.formData.datetimerange[1] || ''
						},
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('onUpdate');
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });   
                } else {
                    return false;
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>

</style>